import { computed } from 'vue';

import { useItemMap } from '@abaninja/helper-item-map';

export const usePageLoaderContext = () => {
  const { deleteItem, items, setItem } = useItemMap<symbol, boolean>();

  const showLoader = computed(() => Boolean(items.value.size));

  return {
    deleteItem,
    setItem,
    showLoader,
  };
};
